<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
              <a class="navbar-brand" href="/"><img width='50px' style='margin-right:10px' src='../../src/assets/ptslogo.png' />PAGARSTAR TECHNOLOGY SERVICE INC.</a>
        </template>
        <template slot="navbar-menu">
            <a class="nav-link" href="about">
                                    About Us
                                </a>
                                   <a class="nav-link" href="services">
                                    Services
                                </a>
                                    <a class="nav-link" href="join">
                                    Join Us
                                </a>
                                  <a class="nav-link" href="contact">
                                    Contact Us
                                </a>
           

           
         

        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    }
  }
</script>

<style scoped>

</style>
